/* eslint-disable @typescript-eslint/no-explicit-any */

import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

interface ApiResponse<T> {
  value: T;
}
interface IFacturaUnicaPuedeProformar {
  titularesMagma: string;
  rutCliente: string | undefined;
}

export const facturaUnicaPuedeProformar = async (
  query: IFacturaUnicaPuedeProformar
): Promise<any> => {
  try {
    const res = await apiClient.post<ApiResponse<any>>(
      Endpoints.FacturaUnicaPuedeProformar,
      {
        titularesMagma: query.titularesMagma,
        rutCliente: query.rutCliente,
      }
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
